import React, { Component } from "react";
import JobTrackIframeEmbed from "components/common/JobTrackIframeEmbed";
import TwoColumnLayout from "layouts/TwoColumn";
import StorageGateway from "lib/storage-gateway";

class IframeBudgetTracking extends Component {
  render() {
    const JobTrackAuthToken = StorageGateway.get("JobTrackBearerToken");
    const JobTrackRefreshToken = StorageGateway.get("jobTrackRefreshToken");
    const orgId = StorageGateway.get("jobTrackOrgId");
    const jwtToken = StorageGateway.get("iframe_jwt_token");
    const tokenExpiry = StorageGateway.get("iframe_jwt_token_expiry") || 3600;

    const iframeSrc = `${process.env.REACT_APP_JOBTRAKS_BASE_URL}screen/280/Employee%20Details?access_token=${JobTrackAuthToken}&jwt_token=${jwtToken}&refresh_token=${JobTrackRefreshToken}&jwt_expiry=${tokenExpiry}&orgId=${orgId}&embed=true`;

    return (
      <TwoColumnLayout hideFooter={true}>
        <JobTrackIframeEmbed src={iframeSrc} />
      </TwoColumnLayout>
    );
  }
}

export default IframeBudgetTracking;
